import * as React from 'react';

import { ContentCard } from '@rematter/ui-web';

import { SidecarFormState } from '../../../_state/sidecarForm.state';
import { SidecarDetailRecord } from '../../../types/sidecar';

import { SidecarFormFields } from './SidecarFormFields';
import { SidecarFormFooterActions } from './SidecarFormFooterActions';

type Props = {
  sidecar?: SidecarDetailRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: SidecarFormState) => void;
  isSaving?: boolean;
};

export const SidecarTabDetails: React.FC<Props> = ({
  sidecar,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => (
  <div className="@SidecarTabDetails flex max-h-full flex-col gap-5 p-5">
    <ContentCard className="p-0 pt-5">
      <SidecarFormFields sidecar={sidecar} />
      <SidecarFormFooterActions
        onSaveUpdates={onSaveUpdates}
        onDiscard={onDiscard}
        isSaving={isSaving}
      />
    </ContentCard>
  </div>
);
